<template>
  <v-modal :isBig="true" :startClosed="true" id="modal-bar-code-reader-somministrations">
    <span slot="header"> Lettore di barcode </span>
    <div id="scanning" class="hero-unit">
      <div class="center"><spinner :visible="loading"></spinner></div>
      <ul ref="ul-for-messages"></ul>
      <span v-show="showInfo">
        <i class="fa-light fa-barcode fa-10x"></i>
        <br />
        Leggi il barcode da una busta
      </span>
    </div>
    <div slot="close">
      <svg id="barcode"></svg>
      <br />
      {{ i18nJS.command.close }}
    </div>
  </v-modal>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import onScan from 'onscan.js';
import vModal from '../vModal';
import spinner from '../spinner';

export default {
  name: 'modalBarCodeReader',
  components: {
    vModal,
    spinner,
  },
  props: {
    timeId: { type: [Number, String], required: true },
    date: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      results: [],
      barcode: null,
      guest_period_data_set_id: null,
      showInfo: true,
      therapies: [],
      opened: false,
      guestSelected: null,
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  watch: {
    results(newVal) {
      if (newVal.length > 0) return;

      this.addLiToUl(`${this.barcode} ${this.i18nJS.barcode_absent}`, 'alert-info');
      this.loading = false;
    },
    guest_period_data_set_id(oldVal, newVal) {
      if (oldVal != newVal) {
        $(this.$refs['ul-for-messages']).html('');
        this.showInfo = true;
      }
    },
  },
  methods: {
    deenovaCode(cod) {
      const regex1 = /^[A-Za-z]{1}[A-Fa-f0-9]{8}$/;
      const regex2 = /^ET[A-Fa-f0-9]{1}[_]{1}\d{1,8}$/;
      const regex3 = /^PD[A-Za-z]{1}[0-9]{2}[0-9]{14}[0-9]{2}$/;
      const regex4 = /^PD[A-Za-z]{1}[0-9]{2}[0-9]{14}$/;
      return cod.match(regex1) || cod.match(regex2) || cod.match(regex3) || cod.match(regex4);
    },
    buildScan() {
      onScan.attachTo(document, {
        keyCodeMapper: function (oEvent) {
          // underscore: 189 google chrome, 173 firefox
          if (oEvent.which == 189 || oEvent.which == 173) {
            return '_';
          }
          // Fall back to the default decoder in all other cases
          return onScan.decodeKeyEvent(oEvent);
        },
        onScan: (sCode) => {
          this.barcode = sCode.toUpperCase();
          if (this.barcode == 'CHIUDI') return $('#modal-bar-code-reader-somministrations').modal('hide');

          this.showInfo = false;
          if (this.opened) this.loading = true;
          this.deenovaCode(this.barcode) ? this.getPreparationsInfo(this.barcode) : this.getByAIC(this.barcode);
        },
      });
    },
    async getByAIC(code) {
      let therapy = this.therapies.find((therapy) => !therapy.id && therapy.guest_drug.aic == code);
      if (!therapy) {
        const eq_cod = await this.getAICEquivalent(code);
        if (!eq_cod) {
          this.addLiToUl('Nessun farmaco equivalente trovato', 'alert-error');
          return (this.loading = false);
        }
        therapy = this.therapies.find((therapy) => therapy.guest_drug.equivalence_cod == eq_cod);
      }
      therapy ? eventBus.$emit('toggleTherapies', therapy, code, false) : (this.loading = false);
    },
    async getAICEquivalent(cod) {
      try {
        const data = await apiConnector().get(`/it/drugs/get_equivalence_cod.json?cod=${cod}`);
        return data.equivalent_cod;
      } catch (exception) {
        this.loading = false;
        console.error(exception);
      }
    },
    getPreparationsInfo(code) {
      const url = `/it/therapies/preparations_from_code/${code}.json`;
      if (this.opened) {
        apiConnector()
          .get(`${url}?guest_period_data_set_id=${this.guest_period_data_set_id}`)
          .then(({ data }) => {
            this.results = data;
            const read_preparations = this.results.filter((preparation) => preparation.read);
            const warning_preparation = this.results.filter((preparation) => !preparation.read && preparation.warning);
            const preparations = this.results.filter((preparation) => !preparation.read && !preparation.warning);
            read_preparations.forEach((preparation) => this.addLiToUl(`${preparation.serial} già letto`, 'alert-warning'));
            warning_preparation.forEach((preparation) =>
              this.addLiToUl(`${preparation.serial} Farmaco erogato non equivalente a quello prescritto`, 'alert-error'),
            );

            preparations.length ? eventBus.$emit('toggleTherapies', preparations, code, true) : (this.loading = false);
          });
      } else {
        apiConnector()
          .get(`${url}?date=${this.date}&time_id=${this.timeId}`)
          .then(({ data }) => {
            if (!data.length) return;

            const gpds = data[0]['guest_period_data_set'];
            if (this.guestSelected == gpds.id) {
              eventBus.$emit('openBarCodeModal');
            } else {
              this.$parent.$emit('guestSelected', gpds);
            }
          });
      }
    },
    showMessages(messages) {
      messages.forEach((message) => {
        const preparation = message.preparation;
        let text, klass;
        if (message.read) {
          klass = 'alert-success';
          text = `${preparation.serial} Terapia somministrata ${preparation.description} per ${preparation.guest_period_data_set.full_name}. Quantità ${preparation.qta}`;
          if (message.message) {
            klass = 'alert-warning';
            text = `${text} ${message.message}`;
          }
          if (preparation.aic != preparation.aic_erogato) {
            klass = 'alert-warning';
            text = `${text}. AIC erogato ${preparation.aic_erogato}`;
          }
        } else {
          klass = 'alert-error';
          text = `${preparation.serial} Terapia non somministrata ${preparation.description} per ${preparation.guest_period_data_set.full_name}`;
          if (message.message) {
            text = `${text} ${message.message}`;
          } else {
            text = `${text} poiché non presente in questo giorno o in questa fascia oraria`;
          }
        }
        this.addLiToUl(text, klass);
      });
      this.loading = false;
    },
    addLiToUl(text, klass = '') {
      const li = document.createElement('li');
      li.classList.add('alert');
      li.classList.add(klass);
      li.append(text);
      $(this.$refs['ul-for-messages']).append(li);
    },
  },
  mounted() {
    this.buildScan();
    window.JsBarcode('#barcode', 'Chiudi', { height: 25, background: '#f5f5f5', font: 'Asap-SemiBold', displayValue: false });
    const modal = $('#modal-bar-code-reader-somministrations');
    this.$parent.$on('guestSelected', (gpds) => (this.guestSelected = gpds.id));
    eventBus.$on('openModalBarCodeReader', (gpds_id, therapies) => {
      this.guest_period_data_set_id = gpds_id;
      this.therapies = therapies;
      modal.modal('show');
      if (this.guestSelected == gpds_id && this.barcode) {
        this.loading = true;
        this.showInfo = false;
        this.getPreparationsInfo(this.barcode);
      }
    });
    modal.on('hidden', () => {
      this.opened = false;
      this.loading = false;
      this.barcode = null;
    });
    modal.on('shown', () => {
      this.opened = true;
    });
    eventBus.$on('stopToggleByBarCode', this.showMessages);
  },
};
</script>
<style lang="scss" scoped>
#scanning {
  text-align: center;
  max-height: 400px;
  overflow-y: scroll;
}
ul {
  list-style-type: none;
}
</style>
